export default "__VITE_ASSET__CvrSsTQV__"